/**
 * /16〜/32 向けの高コントラストパレット。
 * 隣接プレフィックスでも色相がはっきり分かれるよう、青系の連続グラデーションは使わない。
 */
const PREFIX_COLORS: Record<number, string> = {
  16: '#1d4ed8',
  17: '#ea580c',
  18: '#059669',
  19: '#9333ea',
  20: '#dc2626',
  21: '#0891b2',
  22: '#ca8a04',
  23: '#db2777',
  24: '#4f46e5',
  25: '#0d9488',
  26: '#d97706',
  27: '#7e22ce',
  28: '#be123c',
  29: '#0369a1',
  30: '#4d7c0f',
  31: '#a21caf',
  32: '#374151',
};

const GAP_COLOR = '#e8e8e8';
const GAP_HOVER_COLOR = '#d0d0d0';
const LABEL_LIGHT = '#ffffff';
const LABEL_DARK = '#1f2937';

function hexToRgb(hex: string): [number, number, number] {
  const normalized = hex.replace('#', '');
  return [
    parseInt(normalized.slice(0, 2), 16),
    parseInt(normalized.slice(2, 4), 16),
    parseInt(normalized.slice(4, 6), 16),
  ];
}

function relativeLuminance(hex: string): number {
  const channels = hexToRgb(hex).map((value) => {
    const channel = value / 255;
    return channel <= 0.03928
      ? channel / 12.92
      : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}

/**
 * プレフィックス長に対応する色を返す
 */
export function getSubnetColor(prefix: number): string {
  if (prefix in PREFIX_COLORS) {
    return PREFIX_COLORS[prefix];
  }
  if (prefix < 16) {
    return PREFIX_COLORS[16];
  }
  return PREFIX_COLORS[32];
}

/**
 * サブネットブロック上のラベル色（背景とのコントラスト確保）
 */
export function getSubnetLabelColor(prefix: number): string {
  return relativeLuminance(getSubnetColor(prefix)) > 0.45 ? LABEL_DARK : LABEL_LIGHT;
}

export function getGapColor(): string {
  return GAP_COLOR;
}

export function getGapHoverColor(): string {
  return GAP_HOVER_COLOR;
}

/**
 * 使用中プレフィックスの一覧を返す
 */
export function collectUsedPrefixes(prefixes: number[]): number[] {
  return [...new Set(prefixes)].sort((a, b) => a - b);
}
